export enum FollowUpSurveyListType {
    Unknown = 0,
    AllToDo = 1,
    PendingAll = 2,
    PendingSurvey = 3,
    PendingReview = 4,
    PendingAppointment = 5,
    PendingLabOrder = 6,
    PendingLabResults = 7,
    CompleteNoResults = 8,
    PendingNotifyDonor = 9,
    Complete = 10,
    Incomplete = 11,
    All = 12
}